$(function () {
    onLoadCookieBar();
    if (location.href.includes('/cart')) {
      masterPromo(false);
    }
    cartJSEvent();
    initDate();
    initCustomSectionSlider();
    openChatFromPageFly();
    enableAccountUpdateWhenFoundChanges();
    getTaxAttr();
    removeOneCardError();
    initPdpHighlightSlider();
    playVideoInSequence();
    updateHighlightPopupPosition();

    $(window).on('resize', function() {
      initPdpHighlightSlider();
      updateHighlightPopupPosition();
    });
    initMySwiper();
    startCountDown();
});

  //Cookies settings
  setCookies = (cname,cval,days) =>{
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
  
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
  }
  
  getCookies = (cname) =>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  acceptCookies = (e) =>{
    var $this = $(e);
  
    $this.parents('.jsc-cookies-container').hide();
  
    setCookies('jsc-accept-cookie', true, 120);
  }
  
  onLoadCookieBar = () =>{
    var isAccpet = getCookies('jsc-accept-cookie') === 'true';
    if (isAccpet) {
      $('.jsc-cookies-container').hide();
    }
    else {
      $('.jsc-cookies-container').removeClass('d-none');
    }
  }
  // Cookies settings end

  customerAPI = (fn,ln,id,tel,birth,oTel,oBirth,prov,gen,oPro,oGen,oPdpa,nPdpa,pdpaId,pdpaIdList) =>{

    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        old_tel: oTel,
        old_brith: oBirth,
        old_pro: oPro,
        old_gen: oGen,
        old_pdpa: oPdpa,
        pdpa: nPdpa,
        pdpaId: `__id:${pdpaId}`,
        pdpaList: pdpaIdList
    };
  
    $.ajax({
      url: 'https://webhooks.mechanic.dev/4720564e-d928-4c7e-9e58-5e4438209de7',//user/custom/customer
      method: 'POST',
      headers: {
         'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    });
  }
  
  customerInitAPI = (fn,ln,id,tel,birth,prov,gen,pdpa, pdpaId,email) =>{
  
    let $data = {
        id: id,
        first_name: fn,
        last_name: ln,
        telephone: `__tel:${tel}`,
        birthday: `__birthday:${birth}`,
        province: `__province:${prov}`,
        gender: `__gender:${gen}`,
        pdpa: `__pdpa:${pdpa}`,
        pdpaId: `__id:${pdpaId}`,
        email: email
    };
  
    $.ajax({
      url: 'https://webhooks.mechanic.dev/d8c25dbb-5ca9-484a-896d-d8a039efd392', //user/custom/update
      method: 'POST',
      headers: {
         'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    });
  }

  validateUpdate = ($first_name, $last_name, $telephone, $birthday) =>{
    var $isError = true;
  
    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }
    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }
    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        if ($telephone.length == 10) {
        $isError = true;
        $('#telephone_valid').hide();
        } else {
        $isError = false;
        $('#telephone_valid').show();
        }
        $('#telephone_error').hide();
    }
    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }
  
    return $isError;
  }

  updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $id = parseInt($('#jsc-customer-pdpa-id').val());
    var $idList = $('#jsc-customer-pdpa-id-list').val();
    var $shopifyId = parseInt($('#jsc-customer-id').val());
    var $first_name = $('#FirstName').val();
    var $last_name = $('#LastName').val();
    var $email = $('#Email').val();
    var $telephone = $('#jsc-register_mobile').val();
    var $birthday = $('#jsc-birthday').val();
    var $province = $('#jsc-province').val();
    var $gender = $('#jsc-gender').val();
    var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);
  
    var $oldTel = $('#jsc-customter-old-tel').val();
    var $oldBirth = $('#jsc-customter-old-birth').val();
    var $oldProvince = $('#jsc-customter-old-province').val();
    var $oldGender = $('#jsc-customter-old-gender').val();
    var $isConsent = $('#jsc-accepts_marketing').prop('checked');
    var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
    var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';
  
    if($gender == 'Male'){
      $gender = 'ชาย';
    } else if($gender == 'Female'){
      $gender = 'หญิง';
    } else if($gender == 'Others'){
      $gender = 'อื่นๆ';
    }
  
    var $isId = isNaN($id);
  
    if ($isvalidated) {
      if ($isConsent || $isId) {
        var webhook = 'https://webhooks.mechanic.dev/190473be-ebfc-405a-a651-394d476bbea4'; // user/update_pdpa/one
        if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
          $gender = '';
        }
    
        let $data = {
          first_name: $first_name,
          last_name: $last_name,
          birthday: $birthday,
          email: $email,
          telephone: $telephone,
          province: $province,
          gender: $gender,
          isConsent: $isConsent,
          shopify_customer_id: $shopifyId,
          old_tel: $oldTel,
          old_brith: $oldBirth,
          old_pro: $oldProvince,
          old_gen: $oldGender,
          old_pdpa: $oldPdpa,
          pdpa: $newPdpa
        };
        $.ajax({
          url: webhook,
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          data: JSON.stringify($data)
        }).done(function () {
          setTimeout(function(){
            $loader.hide();
            location.reload();
          },24000);
        });
      } else {
        var webhook_2 = 'https://webhooks.mechanic.dev/17ab81dd-10bc-4a22-9ab5-f5deb47d5905'; // user/update_pdpa/two
        if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
          $gender = '';
        }
    
        let $data = {
          id: $id,
          first_name: $first_name,
          last_name: $last_name,
          birthday: $birthday,
          email: $email,
          telephone: $telephone,
          province: $province,
          gender: $gender,
          isConsent: $isConsent,
          shopify_customer_id: $shopifyId,
          old_tel: $oldTel,
          old_brith: $oldBirth,
          old_pro: $oldProvince,
          old_gen: $oldGender,
          old_pdpa: $oldPdpa,
          pdpa: $newPdpa
        };
        $.ajax({
          url: webhook_2,
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          data: JSON.stringify($data)
        }).done(function () {
          setTimeout(function(){
            $loader.hide();
            location.reload();
          },24000);
        });
      }
    } else {
      $loader.hide();
    }
  }

  checkSubscriptionMarketing = (evt) =>{
    var $this = $(evt);
    var $isConsent = $this.prop('checked');
    var $submitButton = $('#subscription-submit');
  
    console.log('checkSubscriptionMarketing - $isConsent: ', $isConsent);
  
    if ($isConsent) {
        $submitButton.removeClass('disabled-submit');
    } else {
        $submitButton.addClass('disabled-submit');
    }
  }
  
  submitSubscriptionPdpa = (evt) => {
    var $this = $(evt);
    var $id = parseInt($("#jsc-customer-pdpa-id").val());
    var $idList = $("#jsc-customer-pdpa-id-list").val();
    var $shopifyId = parseInt($("#jsc-customer-id").val()) || "";
    var $first_name = $("#FirstName").val();
    var $last_name = $("#LastName").val();
    var $email = $("#Email").val();
    var $telephone = $("#jsc-register_mobile").val();
    var $birthday = $("#jsc-birthday").val();
    var $province = $("#jsc-province").val();
    var $gender = $("#jsc-gender").val();
    var $isvalidated = validateUpdate(
      $first_name,
      $last_name,
      $telephone,
      $birthday
    );
  
    var $oldTel = $("#jsc-customter-old-tel").val();
    var $oldBirth = $("#jsc-customter-old-birth").val();
    var $oldProvince = $("#jsc-customter-old-province").val();
    var $oldGender = $("#jsc-customter-old-gender").val();
    var $isConsent = $("#jsc-accepts_marketing").prop("checked");
    var $oldPdpa = $isConsent ? "__pdpa:false" : "__pdpa:true";
    var $newPdpa = $isConsent ? "__pdpa:true" : "__pdpa:false";
  
    var $subscriptionTag = $('#jsc-subscription-tag').val();
  
    console.log('submitSubscriptionPdpa - shopifyId: ', $shopifyId);
  
    if ($gender == "Male") {
      $gender = "ชาย";
    } else if ($gender == "Female") {
      $gender = "หญิง";
    } else if ($gender == "Others") {
      $gender = "อื่นๆ";
    }
  
    var $isId = isNaN($id);

    var emailDOM = $('#Email')[0];
    // console.log('emailDOM.checkValidity(): ', emailDOM.checkValidity());
    if ($email == '') {
      $isvalidated = false;
      $('#email_error').show();
    } else {
      $('#email_error').hide();
      if (!emailDOM.checkValidity()) {
        $isvalidated = false;
        $('#email_invalid_error').show();
      } else {
        $('#email_invalid_error').hide();
      }
    }
  
    if ($isvalidated) {
      // Show thank you modal instead of loader
      let mechanicWebhook = '';
      if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
        $gender = '';
      }
      let $data = {
        first_name: $first_name,
        last_name: $last_name,
        birthday: $birthday,
        email: $email,
        telephone: $telephone,
        province: $province,
        gender: $gender,
        isConsent: $isConsent,
        shopify_customer_id: $shopifyId,
        old_tel: $oldTel,
        old_brith: $oldBirth,
        old_pro: $oldProvince,
        old_gen: $oldGender,
        old_pdpa: $oldPdpa,
        pdpa: $newPdpa,
        subscription_tag: $subscriptionTag
      };
      if ($shopifyId == '') {
        mechanicWebhook = 'https://webhooks.mechanic.dev/850d080e-3883-4012-adb5-b35729693eb0'; // user/subscription_form/submit
      }else if ($isConsent || $isId) {
        mechanicWebhook = "https://webhooks.mechanic.dev/190473be-ebfc-405a-a651-394d476bbea4"; // user/update_pdpa/one
      } else {
        mechanicWebhook ="https://webhooks.mechanic.dev/17ab81dd-10bc-4a22-9ab5-f5deb47d5905"; // user/update_pdpa/two
        $data.id = $id;
      }
      console.log('submitSubscriptionPdpa - mechanicWebhook: ', mechanicWebhook);
      console.log('submitSubscriptionPdpa - $data: ', $data);
  
      $.ajax({
        url: mechanicWebhook,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify($data),
      }).done(function () {
        // Show close button when AJAX is done
        console.log('submitSubscriptionPdpa: ', $('#jsc-subscription-form__container'));
        if ($('#jsc-thank-you__container').length) {
            $('#jsc-thank-you__container').css('display', 'block');
            $('#jsc-subscription-form__container').css('display', 'none');
        }
      });
    } else {
      // Hide modal if validation fails
      console.log('submitSubscriptionPdpa validation failed: ', $('#jsc-subscription-form__container'));
      if ($('#jsc-thank-you__container').length) {
          $('#jsc-thank-you__container').css('display', 'none');
          $('#jsc-subscription-form__container').css('display', 'flex');
      }
    }
  };

  validateRegister = ($first_name, $last_name, $email, $telephone, $birthday, $password) =>{
    var $isError = true;
  
    if ($first_name == '') {
        $('#first_name_error').show();
        $isError = false;
    } else {
        $('#first_name_error').hide();
    }
    if ($last_name == '') {
        $('#last_name_error').show();
        $isError = false;
    } else {
        $('#last_name_error').hide();
    }
    if ($email == '') {
        $('#email_error').show();
        $isError = false;
    } else {
        $('#email_error').hide();
    }
    if ($telephone == '') {
        $('#telephone_error').show();
        $isError = false;
    } else {
        $('#telephone_error').hide();
        if ($telephone.length != 10) {
        $('#telephone_valid').show();
        $isError = false;
        } else {
        if ($telephone.slice(0,1) != '0') {
            $('#telephone_valid').show();
            $isError = false;
        }else {
            $('#telephone_valid').hide();
        }
        }
    }
    if ($birthday == '') {
        $('#birthday_error').show();
        $isError = false;
    } else {
        $('#birthday_error').hide();
    }
    if ($password == '') {
        $('#password_error').show();
        $isError = false;
    } else {
        $('#password_error').hide();
    }
  
    return $isError;
  }
  
  pdpaConsent = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $this = $(evt);
    var $form = $('#create_customer');
    var $first_name = $form.find('input[name="customer[first_name]"]').val();
    var $last_name = $form.find('input[name="customer[last_name]"]').val();
    var $email = $form.find('input[name="customer[email]"]').val();
    var $telephone = $form.find('input[name="telephone"]').val();
    var $birthday = $form.find('input[name="birthday"]').val();
    var $isConsent = $form.find('#jsc-accepts_marketing').prop('checked');
    var $password = $form.find('input[name="customer[password]"]').val();
    var $isvalidated = validateRegister($first_name, $last_name, $email, $telephone, $birthday, $password);
  
  
    setTimeout(function(){
        if ($isvalidated) {
            $('#jsc-customer-tag').val('__tel:'+$telephone+',__birthday:'+$birthday+',__pdpa:'+$isConsent);
            $('#register-submit').click();
        }
        $loader.hide();
    },1800);
  }
  
  initDate = () =>{
    var startDate = new Date(1900, 1 - 1, 1);
    var currentDate = new Date();
    var endDate = new Date(new Date().getFullYear() - 10, currentDate.getMonth(), currentDate.getDate());
    $('#jsc-birthday').datepicker({
        format: 'yyyy-mm-dd',
        startDate: startDate,
        endDate: endDate,
        startView: 2,
        maxViewMode: 2
    });
  }
  
  enableAccountUpdateWhenFoundChanges = () =>{
    // Get the input elements
    var accountPagePdpaInputs = $("#FirstName, #LastName, #jsc-register_mobile, #jsc-birthday, #jsc-province, #jsc-gender, #jsc-accepts_marketing");

    // Get the submit button
    var updatePdpaButton = $("#register-submit");

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
  }
  // End PDPA Function

// JSC Jibbits Addon Feature
(function($) {
    'use strict';
    
    $.fn.sliderResponsive = function( settings ) {
      var set = $.extend({
        anim : 300,
        pause : 3000,
        autoplay: null,
        ratio: null,
        ulClass:'slides-wrapper',
        nextClass:'sl-next',
        prevClass:'sl-prev'
      }, settings);
      
      var $slider = $(this),
          //components
          $next = $slider.find('.'+set.nextClass+''),
          $prev = $slider.find('.'+set.prevClass+''),
          $wrapper = $slider.find('.'+set.ulClass+''),
          $items = $wrapper.find('>li'),
          //dimensions
          n = $items.length,
          ratio = $slider.height()/$slider.width(),
          w, h;
      
      //required styles
      $slider.css('overflow','hidden');
      $wrapper.find('>li:last-child').prependTo($wrapper);
      $wrapper.css({
        'height':'100%',
        'position':'relative'
      });
      $items.css({
        'height':'100%',
        'float':'inline-end'
      });
      
      //dimensions
      function sliderSize() {      
        w = $slider.width();
        $items.width(w);
        $wrapper.width(n*w);
        $wrapper.css('inline-end', -w);
        if (set.ratio === 'keep') {
          h = Math.round(w*ratio); //keep aspect ratio
          $slider.height(h);
        }            
      }
      sliderSize();
      $(window).resize(sliderSize);   
  
   //moving slides
   function next() {
      $wrapper.animate({
        'margin-left':'-='+w
      }, set.anim, function() {
           var $this = $(this);
           $this.find('>li:first-child').appendTo($this);
           $this.css('margin-left',0);
      });
   }//end slNext
      
    function prev() {
     $wrapper.animate({
        'margin-left':'+='+w
      }, set.anim, function() {
           var $this = $(this);
           $this.find('>li:last-child').prependTo($this);
           $this.css('margin-left',0);
      });
     }//end slPrev 
  
    //slide navigation
    $next.on('click', next);  
    $prev.on('click',prev); 
      
    return $slider;
    };  
  }(jQuery));
  
  
  $(document).ready(function() {
    $('.jsc-jibbits-addon').sliderResponsive({
      ulClass:'ul-slides'
    });
  });//end ready

// END JSC Jibbits Addon Feature

// Start CartJS Function
showCartError = (message) => {
  if (!message) return;
  document.querySelectorAll('[data-cart-error]').forEach(function(el) {
    el.textContent = message;
    el.classList.remove('hide');
  });
};

clearCartError = () => {
  document.querySelectorAll('[data-cart-error]').forEach(function(el) {
    el.textContent = '';
    el.classList.add('hide');
  });
};

getCartErrorMessage = (data) => {
  if (!data) return '';
  if (typeof data.description === 'string' && data.description) return data.description;
  if (typeof data.message === 'string' && data.message) return data.message;
  return '';
};

cartJSEvent = () => {
  var $html = `<div class="jsc-page-loading-upt" style="display: none;">
                <div class="jsc-spinner-container">
                  <div class="jsc-spinner"></div>
                </div>
              </div>`;
  $('body').prepend($html);
  $(document).on('cart.requestStarted', function(event, cart) {
      masterpromorun = true;
      $('.jsc-page-loading-upt').removeAttr("style");
      console.log('masterpromorun');
  });
  $(document).on('cart.requestComplete', function(event, cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      masterpromorun = false;
      $('.jsc-page-loading-upt').css("display","none");
      console.log('masterpromoend');
      setTimeout(function(){
        if ($('.cart__items[data-count="0"]').length > 0) {
            location.reload();
        }
      },1000);
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          $('.jsc-loader-overlay').hide();
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            var errorMessage = getCartErrorMessage(jqXHR.responseJSON) || textStatus || errorThrown;
            if (errorMessage) showCartError(errorMessage);
            $('.jsc-loader-overlay').hide();
            $('.jsc-page-loading-upt').css('display', 'none');
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }
    });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback
    
    CartJS.updateItemById(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          if (data && data.status === 422) {
            showCartError(getCartErrorMessage(data));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            return;
          }
          clearCartError();
          $('.jsc-loader-overlay').hide();
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            var errorMessage = getCartErrorMessage(jqXHR.responseJSON) || textStatus || errorThrown;
            if (errorMessage) showCartError(errorMessage);
            console.log("Error occur !", errorThrown,jqXHR,textStatus);
            $('.jsc-loader-overlay').hide();
            $('.jsc-page-loading-upt').css('display', 'none');
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }
    });
}

// Jibbitz bundle: remove all items in a bind group
removeJibbitzBundle = (bindId) => {
  $.when($.getJSON('/cart.js')).then(function(cart) {
    var items = cart.items;
    for (var i = 0; i < items.length; i++) {
      var key = items[i].key;
      var props = items[i].properties || {};
      if (props['_JibbitzBindId'] === bindId) {
        cartJSUpdateQuery(key, 0, {}, true);
      }
    }
  });
  $(document).on('cart.requestComplete', function() {
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
  });
};

// End CartJS Function
//Start onload and onclick all promo
masterPromo = (isDrawer) =>{
  gwpTierFunction(isDrawer);
  cartGift();
  gwpFunction(isDrawer);
  pwpSetValidationCart();
  updateTolimitbundle();
  tierFunction(isDrawer);
  cartGiftProperties();
}
//End onload and onclick all promo

//Start - Gift properties apps
cartGiftProperties = () =>{
  $('.jsc-update-gwp-apps').each(function(){
    var $key = parseInt($(this).val());
    var $qty = parseInt($(this).attr('data-qty'));
    var $gwpcart_product = {};
    $gwpcart_product['_Cart_GWP'] = 'Free Gift';
    cartJSUpdateQuery($key, $qty, $gwpcart_product);
  });
}
//End - Gift properties apps
//Start GWP Tier promo
gwpTierFunction = (isOpenDrawer) =>{
  // $.when($.getJSON('/cart.js', function(cart) {
  
  // })).then(function(cart){
      var $ele = $('._cartGwp');
      var $loader = $('.jsc-loader-overlay');

      $ele.each(function() {
        $loader.show();
        var $gwpcart_product = {};
        var $vid = parseInt($(this).attr('data-vid'));
        var $tierNo = $(this).attr('data-tier');
        var $tierCol = $(this).attr('data-col');
        $gwpcart_product['GWP Tier '+$tierNo] = true;
        $gwpcart_product['_Cart_GWP'] = 'Free Gift';
        if ( $tierCol ) {
          $gwpcart_product['_GWP_col'] = $tierCol;
        }

        if ($(this).length > 0) {
          cartJSAddQuery($vid, 1, $gwpcart_product, isOpenDrawer);
        }
      });
  
  // });

}
//End GWP promo
//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $loader = $('.jsc-loader-overlay');
    var $gwpcart_product = {};
    var $addEle = $('.jsc-add-gwp');
    var $updateEle = $('.jsc-update-gwp');
    var $deleteEle = $('.jsc-remove-gwp');

    $gwpcart_product['_Promo'] = 'Free Gift';

    $addEle.each(function() {
      $loader.show();
      var $vid = parseInt($(this).val());
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      console.log('test');

      cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $updateEle.each(function() {
      $loader.show();
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $deleteEle.each(function() {
      $loader.show();
      var $vid = $(this).val();
      var $qty = 0;

      cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
    });

  });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $loader = $('.jsc-loader-overlay');
  var $elem = $('.jsc-cart-gift');
  $elem.each(function(){
  $loader.show();
  var $vid = parseInt($(this).val());
  var $obj = {};
  var $promoNo = $(this).attr('data-promo');

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0) {
    cartJSAddQuery($vid,1,$obj,true);
  }
  });
  $('.jsc-cart-gift-upt').each(function () {
    $loader.show();
    var $vid = $(this).val();
    var $qty = parseInt($(this).attr('data-qty'));

    var $obj = {};
    var $promoNo = $(this).attr('data-promo');
    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';

    cartJSUpdateQuery($vid, $qty, $obj, false);
  });
}

removeCartGift = () =>{
  var $loader = $('.jsc-loader-overlay');
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function(){
  $loader.show();
  var $key = parseInt($(this).val());

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
  });
}
//End GWP based on cart, product or collection promo
//Start tier discount promo
tierFunction = (isOpenDrawer) =>{
  var $updateEle = $('.jsc-tier-product');
  var $removeEle = $('.jsc-tier-product-remove');

  $updateEle.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount-type');
    var $tierNo = $this.attr('data-promo-no');
    var $qty = parseInt($this.attr('data-qty'));

    $obj['_Quantity-Promo'] = $discountType;
    $obj['_Off-Value'] = $discountVal;
    $obj['_Promo-no'] = $tierNo;
    $obj['_Tier'] = true;

    cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
  });

  $removeEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $promoNo = $this.attr('data-promo-no');
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_Promo-no'];
          delete $thisProps['_Tier'];

          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
          }
        }
      }
    });
  });
}

replaceProduct = ($key, $vid, $qty, isOpenDrawer) =>{
  CartJS.removeItemById($key,
  {
      "success": function(data, textStatus, jqXHR) {
      cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      }
  });
}
//End tier discount promo

//Start variant selected in pdp for bundle and pwp
variantOption = (evt, index, setValue) =>{
  var $this = $(evt);
  var $thisImgUrl = $this.find(':selected').attr('data-img');
  var $thisVid = $this.val();
  var $thisPrice = $this.find(':selected').attr('data-price');
  var $thisTitle = $this.find(':selected').text();
  var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
  var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
  var $currencyFormat = $('html').attr('data-currency');
  var $variantTitleEle = $this.parents('.jsc-promo-grid').find('span.jsc-variant-title');

  var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
  var $discountType = $hiddenEle.val();
  var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-'+$discountType+'-'+index)) : parseInt($hiddenEle.attr('data-'+$discountType+'-'+index));

  // update image
  $this.parents('.jsc-promo-grid').find('img').attr('src', $thisImgUrl);

  // update price
  if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
    var $discountedValue = 0;
    if ($discountType == 'percentage-off') {
      $discountedValue = $thisPrice * $minusPrice;
    } else {
      $discountedValue = $thisPrice - $minusPrice;
    }

    var price = $thisComparePrice;
    var discountprice = $thisPrice;

    console.log($this.siblings('.jsc-price').find('strike'),$this.siblings('.jsc-price').find('span'));

    $this.siblings('.jsc-price').find('strike').text(price);
    $this.siblings('.jsc-price').find('span').text(discountprice);
  } else { // if discount value is empty in theme settings, then show normal price
    if ($thisComparePrice) {
      var comparePrice = $thisComparePrice;
      $this.siblings('.jsc-price').find('strike').text(comparePrice);
      $this.siblings('.jsc-price').find('strike').show();
    } else {
      $this.siblings('.jsc-price').find('strike').hide();
    }
    var price = $thisPrice;
    $this.siblings('.jsc-price').find('span').text(price);
  }

  // update variant ID
  $this.parents('.jsc-promo-grid').attr('data-vid', $thisVid);

  // This function is to hide atc btn and show limit message if pwp reached the set limit
  if (setValue) {
    pwpSetValidationPdp(setValue, $this);
  }

  if ($variantTitleEle.length > 0) {
    $variantTitleEle.html($thisTitle);
  }
}
//End variant selected in pdp for bundle and pwp

//Start PWP promo
pwpAddToCart = (evt,discount2, discountType, index) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_PWP'] = 'Master';
  properties1['_BindID'] = $bindId;
  properties1['_Promo-No'] = index;


  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_PWP'] = 'Child';
  properties2['_BindID'] = $bindId;
  properties2['_Promo-No'] = index;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);

  var cartType = $('#cart-type').val();
  
  /*
  if (cartType == 'page') {
    $(document).on('cart.requestComplete', function(event, cart) {
      if (location.href.includes('/cart')) {
        console.log('no need redirect');
      }else{
        window.location.href = '/cart';
      }
    });
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },500);
  });
  */
}

removePwp = (evt, bindid, pwp) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisProps['_BindID'] == bindid) {

          if (pwp == 'Master') {
            // if customer remove master product we remove the child product
            cartJSUpdateQuery($thisKey, 0, {}, true);
          } else if (pwp == 'Child') {
            // if customer remove child product we keep the master product, but remove the pwp properties
            delete $thisProps['_Quantity-Promo'];
            delete $thisProps['_Off-Value'];
            delete $thisProps['_BindID'];
            delete $thisProps['_PWP'];
            delete $thisProps['_Promo-No'];

            var $isEmptyProperty = $.isEmptyObject($thisProps);
            if ($isEmptyProperty) {
              // if properties is empty then, remove the product and add back
              replaceProduct($thisKey, $vID, $thisQty, true);
            } else {
              // if properties not empty then, just update the properties
              cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
            }
          }
        }
      }
    });
  },900);
  $(document).on('cart.requestComplete', function(event, cart) {
    pwpSetValidationCart();
  });
}

updatePwp = (evt,bindid) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        $thisQty -= 1;
        if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          console.log('slow333', $thisQty);
        }
      }
    });
  },900);
}

pwpSetValidationPdp = (setValue, $this) =>{
  var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
  var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
  var $bId = $v1+'-'+$v2;
  var $isInCart = false;
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;

      if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
        if ($thisQty >= setValue) { // if pwp variant have reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
          $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
        } else { // if pwp variant not yet reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-container').find('.jsc-atc-btn').show();
        }
        $isInCart = true;
      }
    }

    // if variant is not in cart
    if (!$isInCart) {
      $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
      $this.parents('.jsc-container').find('.jsc-atc-btn').show();
    }
  });
}

pwpSetValidationCart = () =>{
  var $pwpContainer = $('.jsc-pwp-container');

  $pwpContainer.each(function(){
    var $this = $(this);
    var $v1 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1+'-'+$v2;
    var $isInCart = false;
    var $setValue = parseInt($this.attr('data-set'));

    if ($setValue) {
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;

          if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
            if ($thisQty >= $setValue) { // if pwp variant have reached set limit
              $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').show();
              $this.parents('.jsc-promoSection').find('.jsc-atc-btn').hide();
            } else { // if pwp variant not yet reached set limit
              $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
              $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
            }
            $isInCart = true;
          }
        }
        // if variant is not in cart
        if (!$isInCart) {
          $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
        }
      });
    }
  });
}
//End PWP promo
//Start bundle promo
bundleAddToCart = (evt,discount1,discount2, discountType, i) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_Quantity-Promo'] = discountType;
  properties1['_Off-Value'] = discount1;
  properties1['_Bundle'] = true;
  properties1['_BindID'] = $bindId;
  properties1['_Promo-no'] = i;

  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_Bundle'] = true;
  properties2['_BindID'] = $bindId;
  properties2['_Promo-no'] = i;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
  
  /*
  var cartType = $('#cart-type').val();
  if (cartType == 'page') {
    $(document).on('cart.requestComplete', function(event, cart) {
      if (location.href.includes('/cart')) {
        console.log('no need redirect');
      }else{
        window.location.href = '/cart';
      }
    });
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },1000);
  });
  */
}

updateTolimitbundle = () =>{
  var $uptEle = $('.jsc-update-bundle-fix');
  $uptEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var discountType = $this.attr('data-discType');
    var discount = $this.attr('data-offvalue');
    var $bindId = $this.attr('data-bindId');
    var i = $this.attr('data-promo');
    var $thisQty = $this.attr('data-qty');
    var properties = {};
    properties['_Quantity-Promo'] = discountType;
    properties['_Off-Value'] = discount;
    properties['_Bundle'] = true;
    properties['_BindID'] = $bindId;
    properties['_Promo-no'] = i;
    properties['_Limit-Discount'] = true;
    cartJSUpdateQuery($key, $thisQty, properties, true);
  });
}

removeBundle = (evt, bindid, key) =>{
  cartJSUpdateQuery(key, 0);
  $(document).on('cart.requestComplete', function(event, cart) {
    bundleCartAjax(bindid);
  });
}

removeBundleOnThemeSettings = () =>{
  var $removeEle = $('.jsc-remove-bundle');

  $removeEle.each(function(){
    var $this = $(this);
    var $bindId = $this.val();
    var $container = $('.'+$this.attr('data-container'));

    if ($container.length > 0) {
      $container.hide();
    }

    setTimeout(function(){
      bundleCartAjax($bindId);
    },900);
  })

}

bundleCartAjax = (bindid) =>{
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisKey = $items[i].key;
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;
      var $vID = parseInt($items[i].variant_id);

      if ($thisProps['_BindID'] == bindid) {
        delete $thisProps['_Quantity-Promo'];
        delete $thisProps['_Off-Value'];
        delete $thisProps['_Bundle'];
        delete $thisProps['_BindID'];
        delete $thisProps['_Promo-no'];

        var $isEmptyProperty = $.isEmptyObject($thisProps);
        if ($isEmptyProperty) {
          // if properties is empty then, remove the product and add back
          replaceProduct($thisKey, $vID, $thisQty, true);
        } else {
          // if properties not empty then, just update the properties
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
        }
      }
    }
  });
}
//End bundle promo

  // Start The 1 & Tax Invoice
  formatString = (n) =>{
    var chars = n.substring(0,3);
    var xChar = n.substr(3).replace(/\D/g,'x');
  
    var newLastName = chars + xChar;
  
    return newLastName;
  }
  oneCardRemove = (e,cusId) => {
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    
    // Run Mechanic webhook
    let $data = {
      customerId: cusId
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/915a7c2e-7f1e-4b0c-b045-5c81aaebadda',
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify($data)
    }).done(function () {
      $('#jsc-id-num').val('');
      $loader.hide();
      $this.hide();
      $('#jsc-one-card-success').show();
    });
  }

  const parseTagsFromLiveCustomerDocument = (doc) => {
    const el = doc.getElementById('LiveCustomerData');
    if (!el) return null;
  
    try {
      const data = JSON.parse(el.textContent.trim());
      return Array.isArray(data.tags) ? data.tags : [];
    } catch (error) {
      return null;
    }
  };

  const fetchLiveCustomerTags = async () => {
    try {
      const response = await fetch(window.location.pathname, { credentials: 'same-origin' });
      if (!response.ok) return null;
      const html = await response.text();
      if (!html.trim()) return null;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return parseTagsFromLiveCustomerDocument(doc);
    } catch (error) {
      console.error('Failed to fetch live customer tags:', error);
      return null;
    }
  };

  const pollForOneCardTag = ($loader, $oneCardNo = '', intervalMs = 1500, timeoutMs = 20000) => {
    const start = Date.now();

    const interval = setInterval(async () => {
      const tags = await fetchLiveCustomerTags();
      console.log('pollForOneCardTag - tags',tags);

      if (tags === null) return;

      const isDone = tags.some((tag) => tag === `${$oneCardNo}_one_card_success` || tag.startsWith(`${$oneCardNo}_one_card_error_`));

      if (!isDone && Date.now() - start < timeoutMs) return;

      clearInterval(interval);
      setTimeout(function(){
        $loader.hide();
        location.reload();
      }, 1000);
    }, intervalMs);
  };

  oneCardVerfication = (e, dT, cusId) =>{
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    var $oneCardNoEle = $('#jsc-id-num');
    var $oneCardNo = $oneCardNoEle.val();
  
    $loader.show();

    if ($oneCardNo != '') {
      $('#jsc-one-card-error').hide();
      let _data = {
        sourceTransID: `CMG_${cusId}_${dT}`,
        requestTime: dT,
        cardNo: $oneCardNo,
        customerId: cusId
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/963f7a2d-c173-40ce-bfd3-081e67a5be89', // user/migrate/onecard
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        setTimeout(function(){
          pollForOneCardTag($loader, $oneCardNo);
        },8000);
      });
    } else {
      $('#jsc-one-card-error').show();
      $('#jsc-one-card-ajax-error').hide();
      $('#jsc-one-card-success').hide();
      $loader.hide();
    }
  }

  removeOneCardError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;
  
    if (isTriggerRemoveTag) {
      var tag_val = $('#trigger-remove-error').val();
      var customer_id = $('#trigger-remove-error').attr('data-id');
      let _data = {
        tag: tag_val,
        customer_id: customer_id
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/d75a2f63-5057-4c83-bbdf-791d39720383', // user/migrate/onecard_remove_error
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        
      });
    }
  }
  
  isInvoice = (e) =>{
    var $this = $(e);
    var $val = $this.val();
    var $html = `<p class="cart-attribute__field jsc-personal-company m-t-15">
      <label class="fontWeight-9 line-height-2 fontSize-s m-b-5 ">คุณต้องการขอใบกำกับภาษีในนามบุคคลหรือนิติบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-personal-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Personal"> <label class="vertical-middle fontWeight-9 cursor p-r-25 inline m-b-0 fontSize-s" for="jsc-personal-radio">ส่วนบุคคล</label>
      <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-company-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Company"> <label class="vertical-middle fontWeight-9 cursor inline m-b-0 fontSize-s" for="jsc-company-radio">ในนามบริษัท</label><br>
    </p>`;
  
    if ($val == 'Yes') {
      $('.jsc-tax-invoice-inputs').append($html);
    } else {
      if ($('.jsc-personal-company').length) {
        $('.jsc-personal-company').remove();
      }
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    }
  }
  
  isPersonalOrCompany = (e) =>{
    var $this = $(e);
    var $val = $this.val();
  
    if ($val == 'Personal') {
      var $html = `<div class="jsc-personal jsc-inputs-details m-t-15">
        <p class="fontWeight-9 line-height-2 m-b-0 fontSize-s">ส่วนบุคคล</p>
        <p class="cart-attribute__field relative m-b-20">
          <label class="fontSize-s m-b-5" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input  class="fontSize-s input-full" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" oninput="saveAttrOnChange(this,'vat_id')">
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn fontSize-s" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-company').length) {
        $('.jsc-company').remove();
      }
    } else {
      var $html = `<div class="jsc-company jsc-inputs-details m-t-15">
        <p class="fontWeight-9 line-height-2 m-b-0 fontSize-s">ในนามบริษัท</p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
          <input required class="required fontSize-s input-full" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" placeholder="เลขประจำตัวผู้เสียภาษี" oninput="saveAttrOnChange(this,'vat_id')">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="company-name">ชื่อบริษัท<span style="color: red;"> *</span></label>
          <input required class="required fontSize-s input-full" id="company-name" type="text" name="attributes[company]" value="" placeholder="ชื่อบริษัท" oninput="saveAttrOnChange(this,'company')">
        </p>
        <p class="cart-attribute__field relative m-b-30">
          <label class="fontSize-s m-b-5" for="branch-type">ประเภทของสำนักงาน<span style="color: red;"> *</span></label>
          <select onchange="onChangeBType(this)" required class="required fontSize-s input-full" id="branch-type" name="attributes[Branch Type]">
            <option value="Headquarter">สำนักงานใหญ่</option>
            <option value="Branch">สาขา</option>
          </select>
        </p>
        <p class="cart-attribute__field m-b-0">
          <label class="fontSize-s m-b-5" for="branch-id">รหัสสาขา<span style="color: red;"> *</span></label>
          <div class="relative">
            <input required class="required fontSize-s full-width input m-b-0" id="branch-id" type="text" maxlength="5" name="attributes[branch_id]" value="00000" placeholder="รหัสสาขา" oninput="saveAttrOnChange(this,'branch_id')">
            <span id="jsc-b-id-overlay"></span>
          </div>
        </p>
        <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
        <span class="btn fontSize-s" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
      </div>`;
      $('.jsc-tax-invoice-inputs').append($html);
      if ($('.jsc-personal').length) {
        $('.jsc-personal').remove();
      }
    }
  }
  
  saveCartAttr = (e) =>{
    var $this = $(e);
    var $inputs = $this.parents('.jsc-inputs-details').find('input');
    var isFilled = true;
  
    $inputs.each(function(){
      var $_this = $(this);
      var $_val = $_this.val();
      console.log('dddd',$_val);
  
      if (!$_val) {
        isFilled = false;
      }
    });
  
    if (isFilled) {
      $('#jsc-required-text').hide();
      $this.html('<span>บันทึกเสร็จแล้ว!</span>');
      cartJSSaveAttr();
    } else {
      $('#jsc-required-text').show();
      $this.html('<span>บันทึกเพื่ออัปเดต</span>');
    }
  }

  cartJSSaveAttr = () =>{
    var input_elements = $('.jsc-tax-invoice').find('input');
    var dataObject = {};
    var isPersonal = false;
  
    input_elements.each(function() {
      var inputType = $(this).attr('type');
      var inputName = $(this).attr('name');
      var inputValue;
  
      if (inputType === 'text') {
        // For text inputs, capture the value directly
        inputValue = $(this).val();
      } else if (inputType === 'radio' && $(this).is(':checked')) {
        // For radio inputs, capture the value only if it's checked
        inputValue = $(this).val();
        if ($(this).val() == 'Personal') {
          isPersonal = true;
        }
      }
  
      // Extract the value inside the square brackets
      var matches = inputName.match(/\[([^\]]+)\]/);
      var key = matches ? matches[1] : null;
  
      if (isPersonal) {
        dataObject['company'] = 'N/A';
        dataObject['branch_id'] = 'N/A';
      }
  
      // Add the data to the object if name and value are defined
      if (inputName && inputValue !== undefined) {
        dataObject[key] = inputValue;
      }
    });
  
    // set attribute
    CartJS.setAttributes(dataObject);
  }
  
  getTaxAttr = () =>{
    
    $.getJSON('/cart.js', function(cart) {
      var cart_attr_obj = cart.attributes;
      console.log('ujuj',cart_attr_obj);
      if (cart_attr_obj.isFullTax) {
        $(`#jsc-${cart_attr_obj.isFullTax.toLowerCase()}-radio`).click();
      }
      if (cart_attr_obj['Are you a Personal or Company (Individual Company)']) {
        $(`#jsc-${cart_attr_obj['Are you a Personal or Company (Individual Company)'].toLowerCase()}-radio`).click();
      }
      if ($('#tax-id').length != 0) {
        $('#tax-id').val(cart_attr_obj.vat_id);
      }
      if ($('#company-name').length != 0) {
        $('#company-name').val(cart_attr_obj.company);
      }
      if ($('#branch-id').length != 0) {
        $('#branch-id').val(cart_attr_obj.branch_id);
      }
    });
    
  }
  
  onChangeBType = (e) => {
    var $this = $(e);
    var $val = $this.val();
  
    if ($val == 'Headquarter') {
      $('#jsc-b-id-overlay').show();
      $('#branch-id').val('00000');
    } else {
      $('#jsc-b-id-overlay').hide();
      $('#branch-id').val('');
    }
  }
  // End The 1 & Tax Invoice

openCity = (evt, cityName) => {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  $(`.${cityName}`).show();
  evt.currentTarget.className += " active";
}

//START responsive carousel

initCustomSectionSlider = () =>{ 
  $(".jsc-responsive-slider").flickity({
    cellAlign: 'left',
    contain: true,
    fade: true,
    wrapAround: true,
    pageDots: false,
    adaptiveHeight: false,
    draggable: true
  });
  console.log( 'carousel at ' );

}

$('.jsc-paginate-groups').on( 'click', '.paginate_each', function() {
  $('.paginate_each').removeClass('active');
  var index = $(this).index();
  var index_plusone = $(this).index() + 1;
  $('.jsc-new-tab').flickity( 'select', index );
  $('.__paginate-nm-'+index_plusone).addClass('active');
});

flickityNextPrev = (e,cls) =>{
  var $this = $(e);
  var $btnElm = $this.parents('.jsc-responsive-slider').find(cls);
  $btnElm.click();
}
//END responsive carousel

//START Announcement bar details
var btn2 = document.getElementById('right_box');
var btnclose = document.getElementById('myBtnClose');
function toggle_visibility(id) {
  var e = document.getElementById(id);
  if(e.style.display == 'block') {
    e.style.display = 'none';
  }
  else {
    e.style.display = 'block';
  }
  console.log('details opened');
  return;
}
function close_btn(id) {
  var e = document.getElementById(id);
  if(e.style.display == 'block') {
    e.style.display = 'none';
  }
  console.log('details closed');
  return;
}
//END ANnouncement bar details

openChat = (e) => {
  var $this = $(e);

  $('#lisa-open-button').click();
}

openChatFromPageFly = () =>{
  $('.jsc-open-chat').click(function(){
    $('#lisa-open-button').click();
  });
}

var typingTimer;
var doneTypingInterval = 1000; // 1000 milliseconds (1 second)
saveAttrOnChange = (e, key) =>{
  clearTimeout(typingTimer);
  typingTimer = setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
      // We can access cart info
      var getCartAttribute = cart.attributes;
      getCartAttribute[key] = $(e).val();
      CartJS.setAttributes(getCartAttribute);
    });
  }, doneTypingInterval);
}
submitJibbitsATC = (e) => {
  const _this = $(e);
  const _form = _this.parents('form');
  var $loader = $('.jsc-loader-overlay');
  // Create a custom promise to handle the form submission
  _form.submit(function(e) {
    e.preventDefault();
    $loader.show();
    $.ajax({
      url: theme.routes.cartAdd,
      type: 'POST',
      data: _form.serialize(),
      dataType: 'json',
      success: function(response) {
        setTimeout(() => {
          $loader.hide();
          _form.get(0).dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response,
              addToCartBtn: _this
            },
            bubbles: true
          }));
        }, 1000);
      },
      error: function(xhr, status, error) {
        $loader.hide();
        console.log('Error: ', error);
      }
    });
  });
}
// start: product highlights
initPdpHighlightSlider = () => {
  var $slider = $('.jsc-product-highlight-wrapper').find('.jsc-product-highlight');
  if($slider.length > 0) {
      $slider.flickity({
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          contain: true,
          wrapAround: false
      });
  }
}

playVideoInSequence = () => {
  var currentIndex = 0;
  var $videos = $('.jsc-product-highlight .jsc-product-highlight-media').find('video.jsc-highlight-media-thumbnail');

  if($videos.length > 0) {
      $videos[currentIndex].play();

      $videos.each(function(index, video) {
          $(video).on('ended', function() {
              if(currentIndex < $videos.length - 1) {
                  currentIndex ++;
                  $videos[currentIndex].play();
              }
          })
      });
  }
}

showHighlightPopup = (evt) => {
  var index = $(evt).find('.jsc-highlight-media-thumbnail').attr('data-index');
  var $popup = $('.jsc-product-highlight-popup[data-index="' + index + '"]');
  if($('video.jsc-highlight-media-full').length > 0) {
    $('video.jsc-highlight-media-full')[0].pause();
  }

  if($popup.length > 0) {
      var $allPopup = $('.jsc-product-highlight-popup');
      $allPopup.removeClass('active');
      $popup.find('.jsc-highlight-media-full')[0].currentTime = 0;
      $popup.addClass('active');
      $('#jsc-custom-chat-widget').addClass('hide-important');
      $popup.find('.jsc-highlight-media-full')[0].play();
  }
}

updateHighlightPopupPosition = () => {
  var $container = $('#main .container');
  if($(window).width() > 1024 && $container.length > 0) {
      var containerRight = $('#main .container')[0].getBoundingClientRect().right;
      var containerPadding = parseInt($('#main .container').css('padding-right'));
      var windowWidth = $(window).width();
      if(containerRight < windowWidth) {
          var rightPos = windowWidth - containerRight + containerPadding;
          $('.jsc-product-highlight-popup').css('right', rightPos + 'px');
      }
  }
  
}

hideHighlightPopup = (evt) => {
  var $popup = $(evt).parent();
  $popup.removeClass('active');
  var popupvideo = $(evt).parents('.jsc-product-highlight-popup');
  if(popupvideo.length > 0) {
    popupvideo.find('.jsc-highlight-media-full')[0].pause();
  }
  $('#jsc-custom-chat-widget').removeClass('hide-important');
}
// end: product highlights
openTabContent = (e) => {
  const _this = $(e);
  const _tabContent = _this.attr('data-control');

  $('.jsc-tab-link').removeClass('active');
  $('.jsc-tab-content label').removeClass('active');

  _this.addClass('active');
  $(`.${_tabContent}-labels`).addClass('active');
}
let mySwiperInstance = {};
initMySwiper = (el) => {
  const swiperId = el ? 'modalSwiper' : 'mySwiper';
  el = el ? el : '.mySwiper';
  var swiper = new Swiper(el, {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 2,
    autoHeight: true,
    spaceBetween: 5,
    mousewheel: true,
    breakpoints: {
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      // when window width is >= 900px
      900: {
        slidesPerView: 4,
        spaceBetween: 5,
      }
    }
  });
  mySwiperInstance[swiperId] = swiper;
  console.log('mySwiperInstance: ', mySwiperInstance);
}
selectAddOns = (e) => {
  const _this = $(e);
  const _parent = _this.closest('.jsc-addon-item');
  var atcTextNode = _this.contents().filter(function() {
    return this.nodeType === 3;
  });

  var isAdding = true;

  if (_parent.hasClass('selected')) {
    isAdding = false;
  }

  const purchaseLabel = _this.closest('.jsc-addon-container').siblings('.jsc-add-ons__header').find('span[data-max-purchase]');
  if (purchaseLabel.length > 0 ) {
    const maxPurchase = parseInt(purchaseLabel.attr('data-max-purchase'));
    const currentpurchase = parseInt(purchaseLabel.attr('data-current-count'));
    const errorMsg = purchaseLabel.siblings('.error');

    var newPurchase = currentpurchase ? currentpurchase : 0;
    if (!isAdding && newPurchase > 0) {
      newPurchase = currentpurchase - 1;
      _parent.removeClass('selected');
      atcTextNode[0].nodeValue = 'Add';
    } else if (isAdding && newPurchase < maxPurchase) {
      newPurchase = currentpurchase + 1;
      _parent.addClass('selected');
      atcTextNode[0].nodeValue = 'Added';
    }

    if (newPurchase >= maxPurchase && isAdding) {
      if (errorMsg.hasClass('d-none')) { errorMsg.removeClass('d-none'); }
    } else {
      if (!errorMsg.hasClass('d-none')) { errorMsg.addClass('d-none'); }
    }
    purchaseLabel.attr('data-current-count', newPurchase);
    purchaseLabel.text(`${newPurchase} of ${maxPurchase} Added to Cart`);
  } else {
    if (isAdding) {
      _parent.addClass('selected');
      atcTextNode[0].nodeValue = 'Added';
    } else {
      _parent.removeClass('selected');
      atcTextNode[0].nodeValue = 'Add';
    }
  }
}
/* start: add ons product */
addAddonsToCart = (e) => {
  const _this = $(e);
  const mainAtcButton = _this.siblings('button[data-add-to-cart]');
  const mainProductVid = _this.siblings('select[name="id"]').val();
  const buyButtonBlock = _this.closest('.product-block');
  const addonsBlock = buyButtonBlock.siblings('.product-block[data-block-type="add_ons"]').find('.jsc-add-ons');
  const addonsItems = addonsBlock.find('.jsc-addon-item');

  var mainPropertiesHTML = '';
  var itemsArray = [];

  if (mainProductVid) {
      var _addOnsId = '';
      console.log('mainProductVid: ', mainProductVid);

      if (addonsItems.length > 0) {
          $(addonsItems).each(function(index, element) {
              if($(element).hasClass('selected')){
                  var _vid = $(element).attr('data-variant-id');
                  _addOnsId != '' ? _addOnsId = _addOnsId + '_' + _vid : _addOnsId = _addOnsId + _vid
                  var _addOnBindId = `${mainProductVid}-${_vid}`;
                  var _addOnObjs = {
                      id: _vid,
                      quantity: 1,
                      properties: {
                          "_bindId": _addOnBindId,
                          "_Add_ons": true
                      }
                  }
                  itemsArray.push(_addOnObjs);
              };
          })
      }

      mainPropertiesHTML = `<input id="mainProduct" type="hidden" name="properties[_Main_product]" value="true"><input id="bindId" type="hidden" name="properties[_bindId]" value="${mainProductVid}-${_addOnsId}">`

      mainAtcButton.before(mainPropertiesHTML);

  }
  console.log('itemsArray: ', itemsArray);
  if (itemsArray.length > 0) {
      CartJS.addItems(itemsArray);
      $(document).on('cart.requestComplete', function(event, cart) {
        console.log('add to cart complete !!!');
        mainAtcButton.click();
      });
  }
  else {
      mainAtcButton.click();
  }
}
/* end: add ons product */
/* start: countdown */
let countdownInstance = {};
startCountDown = (countDownEle) => {
  const countDownId = countDownEle ? 'modalCountdown' : 'countdown';
  countDownEle = countDownEle ? countDownEle : 'span[data-countdown-date]';

  if ($(countDownEle).length > 0) {
    const countDownDate = new Date($(countDownEle).attr('data-countdown-date')).getTime();
    console.log('countDownDate: ', countDownDate);
    // Update the countdown every 1 second
    var x = setInterval(function() {
      var now = new Date().getTime(); // Get the current date and time
      var distance = countDownDate - now; // Find the distance between now and the count down date
      // Calculate time units
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // Display the countdown
      days = days < 10 ? "0" + days : days;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      $(countDownEle).text(`${parseInt(days) > 0 ? days + " Days " : ""}${hours}:${minutes}:${seconds}`);
      // Stop when the countdown ends
      if (distance < 0) {
          clearInterval(x);
          console.log('countdown event EXPIRED');
          if ($(countDownEle).parent().length > 0){
            console.log('countdown parent removed');
            $(countDownEle).parent().remove();
          }
      }
    }, 1000);

    countdownInstance[countDownId] = x;
    console.log('countdownInstance: ', countdownInstance);
  } else {
    console.log('no countdown element found');
  }
}
/* end: countdown */


/****** LoadMore Collection *******/

document.addEventListener("click", function (e) {
  const btn = e.target.closest("#LoadMoreBtn");
  if (!btn) return;

  e.preventDefault();

  if (btn.classList.contains("is-loading")) return;

  btn.classList.add("is-loading");
  btn.innerText = "Loading...";

  const nextUrl = new URL(
    btn.dataset.nextUrl,
    window.location.origin
  );

  const sectionWrapper = document.querySelector(".collection-content");
  const sectionId = sectionWrapper?.dataset.sectionId;

  if (sectionId) {
    nextUrl.searchParams.set("section_id", sectionId);
  }

  fetch(nextUrl)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Load more failed: ${res.status}`);
      }

      return res.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(
        html,
        "text/html"
      );

      const newGrid = doc.querySelector(".jsc-collection-grids");
      const currentGrid = document.querySelector(
        ".jsc-collection-grids"
      );

      if (newGrid && currentGrid) {
        currentGrid.insertAdjacentHTML(
          "beforeend",
          newGrid.innerHTML
        );

        const currentPath =
          window.location.pathname.replace(/\/$/, "");

        const productItems =
          currentGrid.querySelectorAll(".grid-product");

        productItems.forEach((item, index) => {
          // BEST SELLER: 20 item first
          if (
            currentPath === "/collections/best-sellers" &&
            index >= 15
          ) {
            item
              .querySelectorAll(".badge--best-seller")
              .forEach((badge) => badge.remove());
          }

          // TRENDING: 30 item first
          if (
            currentPath === "/collections/trending" &&
            index >= 30
          ) {
            item
              .querySelectorAll(".badge--trending")
              .forEach((badge) => badge.remove());
          }
        });
      }

      // Update Counter
      const counter = document.getElementById("LoadMoreCount");

      if (counter && currentGrid) {
        const total =
          parseInt(counter.dataset.total, 10) || 0;

        const currentCount =
          currentGrid.querySelectorAll(".grid__item").length;

        counter.innerText =
          `You've viewed ${currentCount} of ${total} products`;
      }

      // Update next URL / remove button
      const newBtn = doc.querySelector("#LoadMoreBtn");

      if (newBtn?.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.innerText = "Load more";
        btn.classList.remove("is-loading");
      } else {
        btn.remove();
      }

      if (window.AOS) {
        window.AOS.refreshHard();
      }
    })
    .catch((error) => {
      console.error(error);

      btn.classList.remove("is-loading");
      btn.innerText = "Load more";
    });
});
